"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PdfIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="14" height="16" x="5" y="4" fill="currentcolor" rx="2"/><rect width="8" height="2" x="8" y="8" fill="inherit" rx="1"/><path fill="inherit" d="M15.512 16H13.49a.49.49 0 0 1-.489-.497v-4.006c0-.275.218-.497.489-.497h2.023c.27 0 .488.222.488.497v4.006a.49.49 0 0 1-.488.497"/><rect width="4" height="2" x="8" y="11" fill="inherit" rx="1"/><rect width="4" height="2" x="8" y="14" fill="inherit" rx="1"/></g></svg>`
}, props));
PdfIcon.displayName = 'PdfIcon';
var _default = exports.default = PdfIcon;